import SpinModel from "../../vendor_core/core/src/model/SpinModel";
import { DefaultLayers } from "../../vendor_core/core/src/utils/Layers";
import Layout from "../../vendor_core/core/src/utils/Layout";
import SoundController from "../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../vendor_core/core/src/utils/ViewManager";
import DoubleChanceModel from "../model/DoubleChanceModel";

const changeBottomBarAlpha = (alpha: number = 1): void => {
    const scene = ViewManager.getLayer(
        DefaultLayers.BetBarBottom
    ).getCurrentScene();
    const bottomLine = scene?.sceneSprites?.get("infoBarBottom");
    bottomLine ? (bottomLine.alpha = alpha) : null;
};

const frameAnticipation = (start: boolean): void => {
    const scene = ViewManager.getLayer(
        DefaultLayers.ReelsFront
    ).getCurrentScene();
    const anim = scene.spineAnimations.get("frame_anticipation");
    const coinBarScene = ViewManager.getLayer("CoinBar")?.getCurrentScene();
    const coinAnim = coinBarScene.spineAnimations.get("collection_5");

    const isDoubleChanceActive: boolean = DoubleChanceModel.isActivated;
    const inFreeSpins: boolean = SpinModel.isInFreespins();

    if (start) {
        SoundController.playSound("anticipation", false, null, false);
        coinAnim.play("anticipation", true);

        if (isDoubleChanceActive) {
            anim.playAsync("start_anticipation_db").then(() => anim.playAsync("loop_anticipation_db"));
        } else if (inFreeSpins) {
            anim.playAsync("start_anticipation_fs").then(() => anim.playAsync("loop_anticipation_fs"));
        } else {
            anim.playAsync("start_anticipation_mg").then(() => anim.playAsync("loop_anticipation_mg"));
        }
    } else {
        // coinAnim.stop(false);
        if (isDoubleChanceActive) {
            anim.playAsync("end_anticipation_db").then(() => anim.playAsync("loop_db"));
        } else if (inFreeSpins) {
            anim.playAsync("end_anticipation_fs").then(() => anim.playAsync("loop_fs"));
        } else {
            anim.playAsync("end_anticipation_mg").then(() => anim.playAsync("loop_mg"));
        }
        SoundController.stopSound("anticipation");
    }
};

const formatWinAsSIForCoins = (win: number, customDigits?: number): string => {
    const normalizedWin = win;
    let digits = 2;
    let finalValue: string = "";

    if (typeof customDigits === "number") {
        digits = customDigits;
    }

    if (normalizedWin >= 1e3) {
        const lookup = [
            { value: 1e3, symbol: "K" },
            { value: 1e6, symbol: "M" },
            { value: 1e9, symbol: "G" },
            { value: 1e12, symbol: "T" },
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        const item = lookup
            .slice()
            .reverse()
            .find((item) => normalizedWin >= item.value);

        finalValue = item
            ? (normalizedWin / item.value)
                  .toString()
                  .match(new RegExp(`^-?\\d+(?:\\.\\d{0,${digits}})?`))[0]
                  .replace(rx, "$1") + item.symbol
            : "0";
    } else {
        finalValue = normalizedWin.toFixed(digits);
    }

    if (finalValue.includes(".") || finalValue.includes(",")) {
        for (let i = finalValue.length - 1; i >= 0; i--) {
            if (finalValue[i] === "0") {
                finalValue = finalValue.substr(0, i);
            } else if (finalValue[i] === "." || finalValue[i] === ",") {
                finalValue = finalValue.substr(0, i);
                break;
            } else {
                break;
            }
        }
    }

    if (finalValue.length === 1) {
        finalValue += ".0";
    }
    return finalValue;
};

const prepareTWScene = () => {
    if (ViewManager.getLayer("ThumbleWinCounter").getCurrentScene()) {
    } else {
        const tumbleScene =
            ViewManager.getLayer("ThumbleWinCounter").setScene("open");
        const multiTF = tumbleScene.sceneTextFields.get("multi");
        const winTF = tumbleScene.sceneMoneyFields.get("tw_counter");
        const totalWin = tumbleScene.sceneMoneyFields.get("tw_total");

        if (multiTF) {
            multiTF.alpha = 0;
            multiTF.text = "x 0";
        }

        if (winTF) {
            winTF.value = 0;
            winTF.alpha = 0;
        }

        if (totalWin) {
            totalWin.value = 0;
            // winTF.alpha = 0;
        }

        const twPlate = tumbleScene.groups.get("tw_plate");
        twPlate.visible = false;
    }
};

const Utils = {
    changeBottomBarAlpha,
    frameAnticipation,
    formatWinAsSIForCoins,
    prepareTWScene,
};

export default Utils;
